import Vue from 'vue'
import clientSubscription from '@/utils/client.subscription'

const MUTATION_TYPES = {
  UPDATE_QUIZ_RESPONSE: 'UPDATE_QUIZ_RESPONSE',
}

export const RESULT_KEY_PREFIX = 'ANSWER_RESULTS'

const _state = {
  // Per-slide plugin-quiz results for the streak overlay, keyed by slideId.
  quizResults: {},
}

const _getters = {
  quizResultBySlide: (state) => (slideId) => state.quizResults[slideId],
}

const actions = {
  // TODO: for future development, send version = slide.version to keep the historical quiz result.
  subscribeResultResponseAction: async ({ dispatch }, { audienceId }) => {
    await dispatch('kvSync/subscribeKeyAction', {
      key: `${RESULT_KEY_PREFIX}/${audienceId}`,
    }, {
      root: true,
    })
  },
}

const mutations = {
  [MUTATION_TYPES.UPDATE_QUIZ_RESPONSE](state, quizResult) {
    Vue.set(state.quizResults, quizResult.slide, quizResult)
  },
}

// Native quiz (SubmitQuizResponse): top-level slide -> resolve the parked promise.
// Slide-scoped key stops a stale earlier-slide result resolving the wrong promise.
const resolveNativeQuizResult = (parsed) => {
  const keySubscrible = `${clientSubscription.constantObjectSubcriptionType.submitQuizAnswerType}-${parsed.slide}`
  const parked = clientSubscription.objectSubcription[keySubscrible]
  if (!parked) return
  if (!parsed.id) parsed.id = 1
  parked.resolve(parsed)
  delete clientSubscription.objectSubcription[keySubscrible]
}

// Mirrors general-api constants/typeCorrectAnswer.js.
const VERDICT_TO_TYPE_CORRECT_ANSWER = { WRONG: 1, CORRECT: 2, PARTIALLY_CORRECT: 3 }

// Non-quiz answers (poll, wordcloud) carry no verdict; skip them. `id` lets QuizResult's setPoint run.
const commitPluginQuizResult = (store, result) => {
  if (!result || result.participantId !== store.state.audienceId) return
  if (!result.slideId || !result.verdict) return
  store.commit(`quiz/${MUTATION_TYPES.UPDATE_QUIZ_RESPONSE}`, {
    slide: result.slideId,
    id: 1,
    streak: result.currentStreak || 0,
    lastStreak: result.lastStreak,
    longestStreak: result.longestStreak,
    point: result.points || 0,
    correct: result.verdict === 'CORRECT' || result.verdict === 'PARTIALLY_CORRECT',
    typeCorrectAnswer: VERDICT_TO_TYPE_CORRECT_ANSWER[result.verdict],
  })
}

const plugins = {
  updateQuizResponse: (store) => {
    store.subscribeAction((action) => {
      if (action.type !== 'kvSync/updateKeyValueAction') return
      const { key, value } = action.payload
      const isResultKey = key.includes(`${RESULT_KEY_PREFIX}/`)
      if (!isResultKey || !value) return
      const parsed = JSON.parse(value)

      if (parsed.slide !== undefined) {
        resolveNativeQuizResult(parsed)
        return
      }

      // Plugin quiz (AnswerResponse): streaks nested per result, no top-level slide.
      if (!Array.isArray(parsed.results)) return
      parsed.results.forEach((result) => commitPluginQuizResult(store, result))
    })
  },
}

const quizModule = {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
  plugins,
}

export default quizModule
